<div class="group">
    <div class="flex flex-col gap-1.5">
        <div class="ai-message">
            <div class="message-content flex flex-col gap-1.5">

                <!-- Presented Files (from present_files tool) -->
                @if(getPresentedFileAttachments(message()).length > 0) {
                <div class="w-full js-generated-document">
                    <app-attachment-group [attachments]="getPresentedFileAttachments(message())"
                        [maxVisibleAttachments]="4" [canRemove]="false" [canOpen]="true"
                        [threadId]="threadMessagesService.activeThreadId()"
                        (openAttachment)="onAttachmentOpen($event)"></app-attachment-group>
                </div>

                }

                <!-- Text Content -->
                <div class="prose prose-base max-w-none">
                    <div [innerHTML]="message().content | markdownRender:isOwner()" dynamicComponentRenderer>
                    </div>
                </div>

                <!-- Feedback buttons & Metadata — only visible on final response -->
                @if(message().additional_kwargs?.is_final_response) {
                <div class="flex items-center gap-0.5">
                    <app-button (clicked)="onCopy()" size="sm" [icon]="isCopied() ? 'check-check' : 'copy'"
                        iconSource="lucide" severity="contrast" variant="ghost" pTooltip="Copy"
                        tooltipPosition="bottom" />

                    @if(isOwner()) {
                    <app-button (clicked)="onFeedback(MESSAGE_FEEDBACK.LIKE)" [enableThrottle]="true"
                        [icon]="hasFeedback().like ? 'pi pi-thumbs-up-fill' : 'pi pi-thumbs-up'" iconSource="primeng"
                        [variant]="'ghost'" pTooltip="Good response" tooltipPosition="bottom"
                        [severity]="hasFeedback().like ? 'primary' : 'contrast'">
                    </app-button>
                    <app-button (clicked)="onFeedback(MESSAGE_FEEDBACK.DISLIKE)" [enableThrottle]="true"
                        [icon]="hasFeedback().dislike ? 'pi pi-thumbs-down-fill' : 'pi pi-thumbs-down'"
                        iconSource="primeng" [variant]="'ghost'" pTooltip="Bad response" tooltipPosition="bottom"
                        [severity]="hasFeedback().dislike ? 'danger' : 'contrast'">
                    </app-button>
                    }

                    <!-- Provider Info: sized to match icon-only app-button (size-8 container, sm icon) -->
                    @if(getModelProviderDetails(message()); as providerDetails) {
                    @if(providerDetails.icon) {
                    <div class="size-8 flex items-center justify-center shrink-0" [pTooltip]="providerDetails.model"
                        tooltipPosition="bottom">
                        <div [innerHTML]="providerDetails.icon | sanitizeHtml" class="w-4 h-4 [&>svg]:w-4 [&>svg]:h-4">
                        </div>
                    </div>
                    }
                    }

                    <!-- Mode Badge: Ask / Agentic — sized to match icon-only app-button (size-8 container, sm icon) -->
                    @if(getAgentModeDetails(message()); as modeDetails) {
                    <div class="size-8 flex items-center justify-center shrink-0 cursor-default"
                        [pTooltip]="modeDetails.label" tooltipPosition="bottom">
                        @if(modeDetails.iconSource === 'lucide') {
                        <app-icon [type]="modeDetails.icon" source="lucide" size="sm"></app-icon>
                        } @else {
                        <div [innerHTML]="modeDetails.icon | sanitizeHtml" class="w-4 h-4 [&>svg]:w-4 [&>svg]:h-4">
                        </div>
                        }
                    </div>
                    }

                    <!-- Tool Params -->
                    @if(getToolParamsForAiMessage(message())) {
                    <app-menu #toolParamsMenu [items]="getToolParamsForAiMessage(message())!"
                        [attr.step-id]="'tool-params-menu'">
                        <div (click)="toolParamsMenu.toggle($event)" pTooltip="Tools Used" tooltipPosition="bottom"
                            class="flex items-center gap-1 h-8 bg-gray-100 hover:bg-gray-200 transition-colors rounded-md px-2 cursor-pointer">
                            <span class="text-xs text-gray-800">Tools</span>
                            <span class="text-xs text-gray-600">+{{
                                getToolParamsForAiMessage(message())!.length }}</span>
                        </div>
                    </app-menu>
                    }
                </div>
                }
            </div>
        </div>
    </div>
</div>
